module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/mv_01-3a814cebc06c5c73803de143c68e11fd.jpg";